<template>
  <div class="review" v-bind:style="backgroundStyle">
    <b-field>
        <b-input placeholder="Название компании" v-model="review.title" @change="updateReview(review)"></b-input>
    </b-field>
    <b-field>
        <b-input placeholder="Ссылка на видео" v-model="review.video" @change="updateReview(review)"></b-input>
    </b-field>
    <b-field>
      <b-input placeholder="Краткое описание деятельности" type="textarea" v-model="review.description" height="80px" @change="updateReview(review)"></b-input>
    </b-field>
    <b-field>
      <b-input placeholder="Опишите результат сотрудничества" type="textarea" v-model="review.result" height="80" @change="updateReview(review)"></b-input>
    </b-field>
    <div class="centered">
      <span class="button-wrapper" @click="handleLoadReviewPhoto"><a class="button is-info">+</a>Загрузить фото</span>
    </div>
    <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
    <div class="button-wrapper" @click="deleteReview(review.id)">
      <img src="/static/img/icons/delete.svg" class="delete-icon"/>
      Удалить отзыв с описанием и видео
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'Review',
    data () {
      return {
        base64photo: ''
      }
    },
    props: {
      review: {
        type: Object,
        required: true
      }
    },
    computed: {
      backgroundStyle () {
        return this.review.photo || this.base64photo
        ? {background: !this.base64photo.length ? `url(/upload/photos/${this.review.photo})` : `url(${this.base64photo})`}
        : {background: ''}
      }
    },
    methods: {
      ...mapActions(['deleteReview', 'loadReviewPhoto', 'updateReview']),
      loadPhoto (e) {
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('avatar', file)
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        reader.onload = (e) => {
          this.base64photo = e.target.result
          this.$forceUpdate()
        }
        this.review.newPhoto = formData
        this.updateReview(this.review)
      },
      handleLoadReviewPhoto () {
        this.$refs.loadPhotoButton.click()
      }
    }
  }
</script>

<style scoped>
.review {
  width: 80%;
  padding: 20px;
  margin: 0 auto;
  max-width: 900px;
  position: relative;
  background: #eeeeee;
}

.delete-icon {
  position: initial;
  width: 40px;
  margin: 0 10px 0 0;
}
</style>



// WEBPACK FOOTER //
// Review.vue?4714e0e6